import React, { useEffect, useState } from 'react';
import { useApp } from '../../../context/usePortal';
import PINInputField from './PINInputField';

interface PINVerifactionPopupProps {
  handleVerificationProcessStatusChange: (status: boolean) => void;
  handleAuthStatusChange: (status: string) => void;
  noPinLimit?: number;
  resetPIN?: () => void;
  scanAndPayWithOutPin?: boolean;
  onPinSubmit?: (pin: string) => Promise<{ success: boolean }>;
}

const PINVerificationPopup: React.FC<PINVerifactionPopupProps> = ({
  handleVerificationProcessStatusChange,
  handleAuthStatusChange,
  noPinLimit = 0,
  resetPIN,
  scanAndPayWithOutPin,
  onPinSubmit
}) => {
  const { user, payWithOutPin } = useApp();
  const phoneNumber = user?.country_code + '-' + user?.user_phone_number;
  const [pin, setPin] = useState<string>('');
  useEffect(() => {
    if (pin.length === 6) {
      VerifyPin();
    }
  }, [pin]);
  const VerifyPin = async () => {
    handleVerificationProcessStatusChange(true);

    if (onPinSubmit) {
      try {
        const result = await onPinSubmit(pin);
        if (result?.success) {
          handleAuthStatusChange('succeed');
        } else {
          handleAuthStatusChange('failed');
        }
      } catch {
        handleAuthStatusChange('failed');
      }
      return;
    }

    const { response } = await payWithOutPin(
      !!scanAndPayWithOutPin,
      noPinLimit ?? 0,
      phoneNumber,
      pin
    );
    if (response?.success) {
      handleAuthStatusChange('succeed');
    } else {
      handleAuthStatusChange('failed');
    }
  };

  const handleChangePin = (newValue: string = '') => {
    setPin(newValue);
  };
  const handleForgetPin = () => {
    if (resetPIN) {
      // Close the current PIN verification dialog
      handleVerificationProcessStatusChange(false);
      handleAuthStatusChange('');
      // Trigger the Reset PIN flow
      resetPIN();
    }
  };

  return (
    <div>
      <h2 className="my-2 text-center text-xl font-bold capitalize">
        Enter PIN to continue
      </h2>
      <p className="text-center">Please enter your 6-digit PIN</p>
      <PINInputField length={6} onChangePin={handleChangePin} />
      <button
        type="button"
        className="mx-auto mt-2 block w-full text-center font-semibold capitalize underline"
        onClick={handleForgetPin}
      >
        Forget PIN?
      </button>
    </div>
  );
};

export default PINVerificationPopup;
